import { createAction } from "@reduxjs/toolkit";

import {
  getMyPromotersActionTypes,
  getPromotersByIdActionTypes,
  getMyPromotersPortionActionTypes,
  getPromotersByIdPortionActionTypes,
} from "./actionTypes";

export const getMyPromoters = createAction(
  getMyPromotersActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyPromotersSuccess = createAction(
  getMyPromotersActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyPromotersFailure = createAction(
  getMyPromotersActionTypes.failure,
  (error) => ({ payload: error }),
);

export const getMyPromotersPortion = createAction(
  getMyPromotersPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getMyPromotersPortionSuccess = createAction(
  getMyPromotersPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getMyPromotersPortionFailure = createAction(
  getMyPromotersPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPromotersById = createAction(
  getPromotersByIdActionTypes.request,
  (payload) => ({ payload }),
);

export const getPromotersByIdSuccess = createAction(
  getPromotersByIdActionTypes.success,
  (payload) => ({ payload }),
);

export const getPromotersByIdFailure = createAction(
  getPromotersByIdActionTypes.failure,
  (payload) => ({ payload }),
);

export const getPromotersByIdPortion = createAction(
  getPromotersByIdPortionActionTypes.request,
  (payload) => ({ payload }),
);

export const getPromotersByIdPortionSuccess = createAction(
  getPromotersByIdPortionActionTypes.success,
  (payload) => ({ payload }),
);

export const getPromotersByIdPortionFailure = createAction(
  getPromotersByIdPortionActionTypes.failure,
  (payload) => ({ payload }),
);

export const promotersReset = createAction(getMyPromotersActionTypes.reset);
